import { Pipe, PipeTransform } from "@angular/core";
import { ExtDuration, StatisticItem } from "../../app.models";

@Pipe({ name: "statsSum" })
export class StatisticsPipe implements PipeTransform {
  transform(stats: StatisticItem[] = [], key) {
    if (!stats) {
      return "0";
    }
    if (stats.length === 1) {
      return stats[0][key];
    }
    return stats.reduce((acc, curr) => acc + curr[key], 0);
  }
}

@Pipe({ name: "statsDuration" })
export class StatisticsPipeDuration implements PipeTransform {
  transform(stats: StatisticItem[] = []) {
    if (!stats) {
      return "0";
    }
    const duration = stats.map((app) => {
      return {
        appName: app.appName,
        duration: ((app.finished - app.created) / 1000).toFixed(4),
      };
    });
    return duration;
  }
}

@Pipe({ name: "statsExtDuration" })
export class StatisticsPipeExtDuration implements PipeTransform {
  transform(stats: StatisticItem[] = []) {
    if (!stats) {
      return "0";
    }
    const duration = stats.map((app) => {
      if (app.platformId === 15 || app.platformId === 3) {
        const attempts = app.attemptsWithRetry?.map((attempt) => {
          return {
            attempt: attempt.attempt,
            attempDuration: (
              (attempt.lastFeedbackReceivedOn - attempt.lastPushSendOn) /
              1000
            ).toFixed(4),
            failedCount: attempt.failedCount,
          };
        });
        const extDuration =
          app.lastFeedbackReceivedOn - app.lastPushSendOn > 0
            ? (
                (app.lastFeedbackReceivedOn - app.lastPushSendOn) /
                1000
              ).toFixed(4)
            : null;
        return {
          appName: app.appName,
          serviceName: app.platformId === 15 ? "Firebase" : "APNS",
          extDuration,
          attempts,
        };
      }
    });

    if (!duration) {
      return "0";
    }

    return duration as ExtDuration[];
  }
}

@Pipe({ name: "statsDurationAvg" })
export class StatisticsPipeDurationAvg implements PipeTransform {
  transform(stats: StatisticItem[] = []) {
    if (!stats) {
      return "0";
    }
    if (stats.length === 1) {
      return ((stats[0].finished - stats[0].created) / 1000).toFixed(4);
    }
    return (
      (stats.reduce((acc, curr) => acc + curr.finished, 0) -
        stats.reduce((acc, curr) => acc + curr.created, 0)) /
      stats.length /
      1000
    ).toFixed(4);
  }
}
